// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2ZeAk","bigColWidth":"Table_bigColWidth__o4jdk","biggerColWidth":"Table_biggerColWidth__26St5","row":"Table_row__6oob7","col":"Table_col__1A0R-"};